import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getKhattabatAiMessagesStore from "../../../../stores/khattabat-stores/ai-messages";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import Et3Text from "../../../../core/et3-text";
import i18n from "../../../../constants/i18n";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";

const Header = withLiteObserverAndTheme((props) => {
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get()
  if (isAiKhattaba) {
    return <></>
  }

  const { theme } = props;
  const { colors } = theme;
  const shouldShowConversations =
    getKhattabatAiMessagesStore().isOpenedAiMesssagesBox.get();

  return (
    <ET3Div
      width={1510}
      height={50}
      alignItems={"center"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"space-between"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => { }}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={25}
        isSpan={true}
        text={i18n.get("AI_MESSAGES_BOX")}
        style={{ textDecoration: "underline" }}
        color={""}
      />

      <FontAwesomeIcon
        icon={!shouldShowConversations ? faChevronDown : faChevronUp}
        style={{
          color: colors.all.blue,
          cursor: "pointer"
        }}
        size={"2x"}
        onClick={() => {
          getKhattabatAiMessagesStore().toggleIsOpenedBox();
        }}
      />
    </ET3Div>
  );
});

export default Header;
